__turbopack_context__.v({
  "container": "Table-module__FV8LKG__container",
  "firstColFixed": "Table-module__FV8LKG__firstColFixed",
  "fixed": "Table-module__FV8LKG__fixed",
  "headerCell": "Table-module__FV8LKG__headerCell",
  "hidden": "Table-module__FV8LKG__hidden",
  "icon": "Table-module__FV8LKG__icon",
  "iconWrapper": "Table-module__FV8LKG__iconWrapper",
  "overflow": "Table-module__FV8LKG__overflow",
  "resizeHandle": "Table-module__FV8LKG__resizeHandle",
  "resizing": "Table-module__FV8LKG__resizing",
  "row": "Table-module__FV8LKG__row",
  "scrollToEndButton": "Table-module__FV8LKG__scrollToEndButton",
  "table": "Table-module__FV8LKG__table",
  "touchEnabled": "Table-module__FV8LKG__touchEnabled",
  "wrapper": "Table-module__FV8LKG__wrapper",
});
